/**
 * ListPanel — generic divided list used in Kommunikation, Dokumente, Schäden, Aufgaben, Compliance tabs.
 * Ported from v0 kunden-view.tsx ListPanel helper.
 */
import type { ReactNode } from 'react';

interface ListPanelProps<T> {
  items: T[];
  empty: string;
  render: (item: T) => ReactNode;
}

export function ListPanel<T>({ items, empty, render }: ListPanelProps<T>) {
  if (items.length === 0) {
    return (
      <div className="rounded-lg border bg-card p-8 text-center text-sm text-muted-foreground">
        {empty}
      </div>
    );
  }
  return (
    <div className="divide-y overflow-hidden rounded-lg border bg-card">
      {items.map(render)}
    </div>
  );
}
